<template>
  <b-modal
    :id="modalId"
    modal-class="alert-window"
    :hide-footer="true"
    :hide-header="!titleText"
    @hidden="resetModal"
  >
    <template #modal-header>
      <div
        v-if="titleText"
        role="button"
        href="#"
        class="close-button"
        @click="handleCancel"
      ></div>
      <div>{{ titleText }}</div>
    </template>
    <template slot="default">
      <div class="modal-contents">
        <div
          v-if="!titleText"
          role="button"
          href="#"
          class="close-button"
          @click="handleCancel"
        ></div>
        <!-- <p class="modal-prompt mt-3">{{ alertText }}</p> -->
        <p
          class="modal-prompt mt-3"
          @click="handleContentClick"
          v-html="alertText"
        ></p>
        <div class="d-flex justify-content-center w-75 mb-3 mx-auto">
          <button
            v-if="twoButtons"
            class="cancel-button-red round-new"
            @click="handleCancel"
          >
            {{ cancelButtonText }}
          </button>
          <button class="ok-button-green ms-4 round-new" @click="handleConfirm">
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AlertWindow",
  data() {
    return {
      pendingRoute: null,
      pendingConfirmEvent: null,
    };
  },
  computed: {
    alertText() {
      return this.$store.state.popups.alertWindow.alertText;
    },
    twoButtons() {
      return this.$store.state.popups.alertWindow.twoButtons;
    },
    confirmButtonText() {
      let textInStore = this.$store.state.popups.alertWindow.confirmButtonText;
      if (textInStore) {
        return textInStore;
      } else {
        return "Ok";
      }
    },
    cancelButtonText() {
      let textInStore = this.$store.state.popups.alertWindow.cancelButtonText;
      if (textInStore) {
        return textInStore;
      } else {
        return "Cancel";
      }
    },
    redirectUrl() {
      return this.$store.state.popups.alertWindow.redirectUrl;
    },
    modalId() {
      return this.$store.state.popups.alertWindow.modalId;
    },
    titleText() {
      return this.$store.state.popups.alertWindow.titleText;
    },
  },
  mounted() {
    if (this.modalId) {
      this.$bvModal.show(this.modalId);
    }
  },
  methods: {
    handleContentClick(e) {
      const link = e.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href");
      if (!href) return;

      e.preventDefault();

      this.pendingRoute = href;

      if (this.modalId) {
        this.$bvModal.hide(this.modalId);
      }
    },

    handleConfirm() {
      this.pendingConfirmEvent = `ok-${this.modalId}`;

      if (this.redirectUrl) {
        this.pendingRoute = this.redirectUrl;
      }

      if (this.modalId) {
        this.$bvModal.hide(this.modalId);
      }
    },

    handleCancel() {
      this.pendingConfirmEvent = null;
      this.pendingRoute = null;

      if (this.modalId) {
        this.$bvModal.hide(this.modalId);
      }
    },

    resetModal() {
      const routeToGo = this.pendingRoute;
      const eventToEmit = this.pendingConfirmEvent;

      this.pendingRoute = null;
      this.pendingConfirmEvent = null;

      this.$store.dispatch("popups/clearModalContent");

      if (eventToEmit) {
        this.$root.$emit(eventToEmit);
      } else {
        this.$root.$emit("cancel");
      }

      if (routeToGo) {
        this.$router.push(routeToGo);
      }
    },
  },
};
</script>
<style lang="scss">
.alert-window {
  .close-button {
    right: -16px;
    top: -16px;
    width: 32px;
    height: 32px;
  }
  .modal-header {
    border: none !important;
    justify-content: center;
    text-transform: uppercase;
    font-size: 22px;
    color: $popup-text-light-gold;
  }
  .modal-content {
    color: white;
    text-align: center;
    background-color: transparent;
    background-image: linear-gradient(#123445, $bg-gradient-navy-blue);
    border: solid 2px $primary-accent;
    border-radius: 16px;
    box-shadow: 0 0 60px rgba(77, 229, 255, 0.66),
      0 0 30px rgba(77, 229, 255, 0.66), 0 0 15px $drop-shadow-dark,
      0 0 15px $drop-shadow-dark, 0 0 4px $drop-shadow-dark;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-size: 100% 100%;
  }
  .modal-body {
    padding: 0;
  }

  .modal-contents {
    width: 100%;

    min-height: 128px;
    .modal-prompt {
      padding: 8px;
      font-size: 18px;
    }
  }
  .alert-support-link {
    margin-top: 8px;
    font-size: 14px;

    a {
      color: $text-light-gold; // or white, depending on your design
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: lighten($text-light-gold, 10%);
        filter: drop-shadow(0 0 4px $text-light-gold);
      }
    }
  }
}
</style>
